import {WhitelabelEvent, WhitelabelEventWithPayload} from "../../../../../../common/ts/events/Events";
import {SuccessEvent} from "../../../../../../common/ts/core/http";

interface ShowRetentionCaptureModalRequestedPayload {
    search: string;
    hasPreviousSuggestions: boolean;
}

export class ShowRetentionCaptureModalRequestedEvent implements WhitelabelEventWithPayload<ShowRetentionCaptureModalRequestedPayload> {
    payload: ShowRetentionCaptureModalRequestedPayload;
    type: string;
    static readonly TYPE: string = 'show-retention-capture-modal-requested'

    constructor(payload: ShowRetentionCaptureModalRequestedPayload) {
        this.type = ShowRetentionCaptureModalRequestedEvent.TYPE;
        this.payload = payload;
    }
}

export class ShowRetentionPopupMobileRequestedEvent implements WhitelabelEvent {
    type: string;
    static readonly TYPE: string = 'show-retention-popup-mobile-requested';

    constructor() {
        this.type = ShowRetentionPopupMobileRequestedEvent.TYPE;
    }
}

interface AlertSuggestionsReceivedPayload {
    response: string[]
}

export class AlertSuggestionsReceivedEvent implements WhitelabelEventWithPayload<AlertSuggestionsReceivedPayload> {
    payload: AlertSuggestionsReceivedPayload;
    type: string;
    static readonly TYPE: string = 'alert-suggestions-received';

    constructor(payload: AlertSuggestionsReceivedPayload) {
        this.type = AlertSuggestionsReceivedEvent.TYPE;
        this.payload = payload;
    }
}

export class EmptyEvent implements WhitelabelEvent {
    type: string;
    static readonly TYPE: string = 'empty-event';

    constructor() {
        this.type = EmptyEvent.TYPE;
    }
}

interface SaveEmailAlertRequestedPayload {
    searches: string[],
    email: string,
    wantNews: boolean,
    successEvent?: SuccessEvent,
}

export class SaveEmailAlertRequestedEvent implements WhitelabelEventWithPayload<SaveEmailAlertRequestedPayload> {
    payload: SaveEmailAlertRequestedPayload;
    type: string;
    static readonly TYPE: string = 'save-email-alert-requested';

    constructor(payload: SaveEmailAlertRequestedPayload) {
        this.type = SaveEmailAlertRequestedEvent.TYPE;
        this.payload = payload;
    }
}
